// import Main from "./pages/Main";
// import NewProduct from "./pages/NewProduct";
// import ProductList from "./pages/ProductList";
// import About from "./pages/About";
// import Navbar from "./components/Navbar";
import AppRouter from "./router/AppRouter";
function App() {
  return (
    <div className="bg-light app">
      <AppRouter />
    </div>
  );
}

export default App;
